<template>
  <div :class="$style.formContainer">
    <LoginCard
      header="User Password Reset"
    >
      <LoginAlert v-model="errorMessage" />
      <ResetPassword
        clientType="user"
        :form="form"
        :isLoading="isLoading"
        :submit="submit"
      />
    </LoginCard>
    <LogoIcon />
  </div>
</template>

<script>
// Components
import LoginAlert from 'client/components/LoginAlert.vue';
import LoginCard from 'client/components/LoginCard.vue';
import LogoIcon from 'client/components/LogoIcon.vue';
import ResetPassword from 'client/components/forms/ResetPassword.vue';

// Services
import userResetPasswordService from 'client/services/userResetPasswordService';

export default {
  name: 'UserResetPasswordInputHandler',

  components: {
    LoginAlert,
    LoginCard,
    LogoIcon,
    ResetPassword,
  },

  props: {
    errorMessage: {
      type: String,
      default: '',
    },
    form: {
      type: Object,
      required: true,
    },
    requestKey: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  methods: {
    async submit() {
      this.isLoading = true;
      this.form.deviceCode = await userResetPasswordService.getDeviceCertCode();

      try {
        await userResetPasswordService.resetPassword(this.requestKey, this.form);
        this.$emit('success');
      } catch (error) {
        this.$emit('error', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style module>
@import '../../../css/login-components.css';
</style>
